import { jsx } from "react/jsx-runtime";
import { Children, isValidElement } from "react";
import { Divider } from "../Divider/index.js";
const getComponentType = (child)=>{
    if (!child.props) return null;
    const id = child.props['data-id'];
    if ('carousel-numbers-text' === id) return 'numbers';
    if ('carousel-lightbox-button' === id) return 'lightbox';
    if ('carousel-autoplay-button' === id) return 'autoplay';
    return null;
};
const CarouselBlurBox = ({ children, slotClassNames = {} })=>{
    if (!children) return null;
    const validChildren = Children.toArray(children).filter((child)=>/*#__PURE__*/ isValidElement(child));
    if (0 === validChildren.length) return null;
    const { blurBoxClasses = '', blurBoxDividerClasses = '' } = slotClassNames;
    const numbersComponents = validChildren.filter((child)=>'numbers' === getComponentType(child));
    const lightboxComponents = validChildren.filter((child)=>'lightbox' === getComponentType(child));
    const autoplayComponents = validChildren.filter((child)=>'autoplay' === getComponentType(child));
    const renderContent = ()=>{
        const elements = [];
        if (numbersComponents.length > 0) elements.push(...numbersComponents);
        if (lightboxComponents.length > 0) elements.push(...lightboxComponents);
        if (autoplayComponents.length > 0 && elements.length > 0) elements.push(/*#__PURE__*/ jsx(Divider, {
            direction: "vertical",
            type: "solid",
            weight: 1,
            className: blurBoxDividerClasses,
            "data-testid": "carousel-blur-box-divider"
        }, "carousel-blur-box-divider"));
        if (autoplayComponents.length > 0) elements.push(...autoplayComponents);
        return elements;
    };
    const content = renderContent();
    if (0 === content.length) return null;
    return /*#__PURE__*/ jsx("div", {
        "data-testid": "carousel-blur-box",
        className: blurBoxClasses,
        children: content
    });
};
export { CarouselBlurBox };
